/**
 * @file
 */
import AOS from 'aos'

export default function app() {

  let header_home_menu = false;
  let macy;

  const js_header__menu_icon = document.querySelector('.js-header__menu-icon');
  const js_header__menu__container = document.querySelector('.js-header__menu__container');
  const js_header__menu__elements = document.querySelectorAll('.header__menu__link');

  const closeLoader = () => {
    const preloader = document.querySelector('#preloader');
    const preloader__wrapper = document.querySelector('.preloader__wrapper');

    if (!preloader || !preloader__wrapper) { return; }

    preloader.classList.add('closing');
    setTimeout(() => {
      preloader__wrapper.classList.add('closed');
    }, 600);
    setTimeout(() => {
      preloader.classList.add('closed');
    }, 1200);
  };

  const headerHomeMenuController = () => {
    if (js_header__menu_icon) {
      js_header__menu_icon.addEventListener('click', e => {
        header_home_menu ? closeMenu() : openMenu()
      });
    }
    Array.from(js_header__menu__elements).forEach(el => {
      el.addEventListener('click', () => {
        closeMenu();
      })
    })
  };
  const openMenu = () => {
    js_header__menu_icon ? js_header__menu_icon.classList.add('active') : '';
    js_header__menu__container ? js_header__menu__container.classList.add('active') : '';
    js_header__menu__container ? js_header__menu__container.style.zIndex = 10 : '';
    //js_header__menu__container ? js_header__menu__container.style.display = 'block' : '';
    header_home_menu = true;
  };
  const closeMenu = () => {
    js_header__menu_icon ? js_header__menu_icon.classList.remove('active') : '';
    js_header__menu__container ? js_header__menu__container.classList.remove('active') : '';
    header_home_menu = false;
    setTimeout(() => {
      js_header__menu__container ? js_header__menu__container.style.zIndex = -1 : '';
      //js_header__menu__container ? js_header__menu__container.style.display = 'none' : '';
    }, 200);
  };

  const macyController = () => {
    if (document.querySelector('#macy-container')) {
      macy = Macy({
        container: '#macy-container',
        trueOrder: false,
        waitForImages: false,
        margin: 24,
        columns: 3,
        breakAt: {
          800: 2,
        }
      });
    }
  };

  const simpleParallaxController = () => {
    const image = document.getElementsByClassName('parallax-image');
    if (!image) { return; }
    const parallax = new simpleParallax(image, {
      delay: 0,
      orientation: 'up',
      scale: 1.3,
      overfow: false
    });
  };

  const scrollController = () => {
    const content = document.querySelector('.contrast--content');
    if (!content) { return; }

    (window.scrollY > (content.offsetHeight - 140)) ?
      js_header__menu_icon.classList.remove('white') :
      js_header__menu_icon.classList.add('white');
    window.onscroll = function(e) {
      (window.scrollY > (content.offsetHeight - 140)) ?
        js_header__menu_icon.classList.remove('white') :
        js_header__menu_icon.classList.add('white');
    }
  };

  function setCookie(cname, cvalue, exdays){
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function cookie() {
    if (!getCookie('lflDisc')) {

      const cookie_bar = document.querySelector('#cookie-bar');
      const cookie_accept = document.querySelector('#cookie-accept');

      if(!cookie_bar || !cookie_accept) { return; }

      cookie_bar.classList.remove('hidden');
      cookie_accept.addEventListener('click', function (e) {
        e.preventDefault();
        setCookie('lflDisc', true, 365);
        cookie_bar.classList.add('hidden');
      });
    }
  }

  function getUrlParams() {
    const params = [];
    const hash = window.location.hash;
    if (!hash) return false;
    const split = hash.replace(/^#/,'').split('&');
    split.forEach(el => {
      let pair = el.split('?')
      params[pair[0]] = pair[1];
    });
    return params;
  }

  function newsletterSignup() {
    const params = getUrlParams();
    const hash = window.location.hash;
    if (params['newsletter_signup'] === 'success') {
      const newsletter_signup__confirmation = document.querySelector('.newsletter_signup__confirmation');
      if (!newsletter_signup__confirmation) return false;
      newsletter_signup__confirmation.classList.remove('hide');

      const js_confirmation__hide = document.querySelector('.js-confirmation__hide');
      if (!js_confirmation__hide) return false;
      js_confirmation__hide.addEventListener('click', () => {
        newsletter_signup__confirmation.classList.add('hide');
      })

      setTimeout(() =>{
        newsletter_signup__confirmation.classList.add('hide');
      }, 60000);

      window.location.hash = hash.replace('newsletter_signup?success', '')
    }
  }

  const recaptcha = () => {
    console.log('text')
    //document.addEventListener("DOMContentLoaded", function() {



      if (grecaptcha && grecaptcha.enterprise) {
        grecaptcha.enterprise.ready(function () {
          const form = document.querySelector('.js-contact-form');
          if (!form) return;

          form.addEventListener('submit', function(e) {
            e.preventDefault();

            grecaptcha.enterprise.execute('{{ recaptcha_key }}', {action: 'contact_form'})
              .then(function(token) {

                console.log(token)

                const tokenInput = document.querySelector('input[name="recaptcha"]');
                if (tokenInput) {
                  tokenInput.value = token;
                }
                form.submit();
              });
          });
        });
      }
    //});
  }

  const init = () => {
    AOS.init({
      once: true,
    });
    headerHomeMenuController();
    macyController();
    simpleParallaxController();
    scrollController();
    cookie();
    newsletterSignup();

    const contact = document.querySelector('.js-contact-form');
    if (contact) {
      //recaptcha();
    }

    /*document.querySelectorAll('img')
      .forEach((img) =>
        img.addEventListener('load', () =>
          AOS.refresh()
        )
      );*/
  };

  const initLoaded = () => {
    closeLoader();
  };

  init();

  document.addEventListener("DOMContentLoaded", () => {
    initLoaded();
  });

}
